// src/hooks/useSaveDefaultPage.ts
import { useMutation } from "@apollo/client";
import { UPDATE_PROFILE } from "../graphql/mutations";
import { useContext } from "react";
import { UserContext } from "../components/auth/auth-context";

export function useSaveDefaultPage() {
  const [updateProfile] = useMutation(UPDATE_PROFILE);
  const { providerUser } = useContext(UserContext);
  return async (newPageId: number, businessId?: number) => {
    const res = await updateProfile({
      variables: {
        userId: Number(providerUser.userId),
        email: providerUser.email,
        username: providerUser.username,
        hours24: providerUser.hours24,
        timeZoneId: providerUser.timeZone?.id,
        desc: providerUser.desc,
        planId: providerUser.planId,
        calendar: providerUser.calendar,
        defaultBusinessId: Number(businessId)|| providerUser.defaultBusinessId,
        defaultPageId: newPageId,
      },
    });
    if (res.data?.updateProfile?.token) {
      localStorage.setItem("token", res.data.updateProfile.token);
    }
  };
}
